<template>
<div>
  <!--http://192.168.15.20:8080/#/promotion?pc=BPK0LGJ4
  http://192.168.15.20:8080/#/promotion?pc=VHCEZZUW-->

</div>
</template>

<script>
  import axios from 'axios'
  import "./../assets/css/base.css";
  import "@/assets/css/product.css";
  import "@/assets/css/index.css?version=1.0.1";
  import {setCookie} from "../util/util";
export default {
    name: "promotion",
    data() {
        return {
          promotedId:'',
          promotedType:''
        };
    },
  mounted() {
    this.getUrl();
  },
  methods: {
    getUrl() {
      setCookie("pc", this.$route.query.pc, 30);
      axios.get("jys/promotion/info/" + this.$route.query.pc).then((res) => {
        console.log('promition res', res)
        if (res.data.promotion === null) {
          alert("二维码失效了");
        } else {
          this.promotedId = res.data.promotion.promotedId;
          this.promotedType = res.data.promotion.promotedType;
          // 被推广物料类型 0: 店铺  1: 商品
          if (this.promotedType === 0) {
            this.$router.push({
              path: '/company/index',
              query: {
                id: this.promotedId
              }
            })
          }
          if (this.promotedType === 1) {
            this.$router.push({
              path: '/detection',
              query: {
                id: this.promotedId
              }
            })
          }
        }
      })
    },
  }
};

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/promotion.vue